export const SET_STATISTICS_PER_ORDER_TYPE = 'SET_STATISTICS_PER_ORDER_TYPE'
export const SET_STATISTICS_PER_PAYMENT_METHOD = 'SET_STATISTICS_PER_PAYMENT_METHOD'
export const SET_STATISTICS_LOADING = 'SET_STATISTICS_LOADING'
export const SET_STATISTICS_ITEMS = 'SET_STATISTICS_ITEMS'
export const ADD_STATISTICS_ITEMS = 'ADD_STATISTICS_ITEMS'
export const SET_STATISTICS_ITEMS_LENGTH = 'SET_STATISTICS_ITEMS_LENGTH'
